export const Required = (value) => {
  if (value && Array.isArray(value)) {
    return value.length ? undefined : "Required";
  } else {
    return value ? undefined : "Required";
  }
};

export const DescriptionRequired = (value) => {
  if (value && Array.isArray(value)) {
    return value.length ? undefined : "We're sorry.  A brief description is required.";
  } else {
    return value ? undefined : "We're sorry.  A brief description is required.";
  }
};

export const MaxDescriptionRequired = (value) => {
  if (value) {
    return value.length > 500 ? "Maximum 500 characters allowed" : undefined;
  }
};

export const PhoneNumberRequired = (value) => {
  if (value && Array.isArray(value)) {
    return value.length ? undefined : "We’re sorry. That is not a valid number.";
  } else {
    return value ? undefined : "We’re sorry. That is not a valid number.";
  }
};

export const OTPPassword = (value) => {
  if (value && value.length !== 6) {
    return "Must be 6 characters.";
  } else {
    return undefined;
  }
};

export const maxLength = (max) => (value) =>
  value && value.length > max ? `Must be ${max} characters or less` : undefined;

export const maxLength15 = maxLength(15);

export const number = (value) => (value && isNaN(Number(value)) ? "Must be a number" : undefined);

export const minValue = (min) => (value) =>
  value && value < min ? `Must be at least ${min}` : undefined;

export const minValue18 = minValue(18);

const onlyNumberValidator = (value, expectedLength, fieldName) => {
  let errorMsg;
  if (!value) {
    return errorMsg;
  }
  if (value.length !== expectedLength) {
    errorMsg = `${fieldName} must be ${expectedLength} digits long`;
  }

  if (!/^\d+$/.test(value)) {
    errorMsg = `${fieldName} cannot contain any other digits`;
  }
  return errorMsg;
};

const onlyPhoneNumberValidator = (value, expectedLength, fieldName) => {
  let errorMsg;
  if (!value) {
    return errorMsg;
  }
  if (value.length !== expectedLength) {
    errorMsg = "We’re sorry. That is not a valid number.";
  }

  if (!/^\d+$/.test(value)) {
    errorMsg = `${fieldName} cannot contain any other digits`;
  }
  return errorMsg;
};

const numberValidator = (value) => {
  let errorMsg;
  if (!value) {
    return errorMsg;
  }

  if (!/^\d+$/.test(value)) {
    errorMsg = "Should enter only numbers.";
  }
  return errorMsg;
};

export const zip = (value) => onlyNumberValidator(value, 5, "Zip");

export const onlyNumbers = (value) => numberValidator(value);

export const phone = (value) =>
  onlyPhoneNumberValidator(value, 10, "Phone number");

export const emailValidator = (value) =>
  value && !/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,4}$/i.test(value)
    ? "We’re sorry. Please enter a valid email address."
    : undefined;

export const tooOld = (value) =>
  value && value > 65 ? "You might be too old for this" : undefined;

export const aol = (value) =>
  value && /.+@aol\.com/.test(value)
    ? "Really? You still use AOL for your email?"
    : undefined;

export const validForm = (requiredFields = [], values) => {
  const errors = {};
  requiredFields.forEach((item) => {
    if (
      !values[item] ||
      (Array.isArray(values[item]) && values[item].length === 0)
    ) {
      errors[item] = "Required";
    }
  });
  return Object.keys(errors).length === 0 ? true : false;
};

export const PasswordMatch = (value, allValues) => {
  if (value && Array.isArray(value)) {
    return value.length ? undefined : "Required";
  } else {
    // const password = allValues.newPassword;
    // const confirmPassword = allValues.confirmNewPassword;
    if (value) {
      return value !== allValues.newPassword
        ? "We’re sorry. The passwords do not match."
        : undefined;
    } else {
      return "Required";
    }
    // if (value) return value ? undefined : "Required";
  }
};

export const PasswordValidityMatch = (value) => {
  if (value && Array.isArray(value)) {
    return value.length ? undefined : "Required";
  } else {
    let regExp = new RegExp("^(?=.*\\d)(?=.*[a-z])(?=.*[A-Z]).{6,}$");
    if (value) {
      return regExp.test(value) ? undefined : true;
    } else {
      return "Required";
    }
  }
};

export const EmailMatch = (value, allValues) => {
  if (value && Array.isArray(value)) {
    return value.length ? undefined : "Required";
  } else {
    if (value) {
      return value.match(allValues.newEmail)
        ? undefined
        : "We’re sorry. The email addresses do not match.";
    } else {
      return "Required";
    }
  }
};

export const validURL = (value) => {
  const res = value.match(
    /(http(s)?:\/\/.)?(www\.)?[-a-zA-Z0-9@:%._+~#=]{2,256}\.[a-z]{2,6}\b([-a-zA-Z0-9@:%_+.~#?&//=]*)/g
  );
  if (res !== null) {
    return undefined;
  } else {
    return "Invalid URL";
  }
};

export const PhonenumberMatch = (value, allValues) => {
  if (value && Array.isArray(value)) {
    return value.length ? undefined : "Required";
  } else {
    // const password = allValues.newPassword;
    // const confirmPassword = allValues.confirmNewPassword;
    if (value) {
      return value.match(allValues.phonenumber)
        ? undefined
        : "We’re sorry. The phone numbers do not match.";
    } else {
      return "Required";
    }
    // if (value) return value ? undefined : "Required";
  }
};
